import { createFileRoute } from '@tanstack/react-router';

import { ContactDetailsPanel } from './-components/contact-details-panel';

export const Route = createFileRoute('/_dashboard/tasks/')({
  component: TasksIndexRoute,
});

function TasksIndexRoute() {
  return <ContactDetailsPanel contact={null} />;
}
